// src/components/ChatWidget.js
import { useEffect } from "react";

const ChatWidget = () => {
    useEffect(() => {
        //var Tawk_API = window.Tawk_API || {};
        ///var Tawk_LoadStart = new Date();

        var s1 = document.createElement("script");
        var s0 = document.getElementsByTagName("script")[0];

        s1.async = true;
        s1.src = "http://embed.tawk.to/692ea421476ecf197b9135d7/1jbf3290g"; // ✅ Script MỚI của bạn
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");

        s0.parentNode.insertBefore(s1, s0);
    }, []);

    return null;
};

export default ChatWidget;
